import React from 'react'
import { Divider as MDivider, DividerProps as MDividerProps } from '@material-ui/core'

export type DividerProps = MDividerProps

export default function Divider (props: DividerProps) {
  return (
    <MDivider
      {...props}
    />
  )
}
